/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  KillswitchMutationReceipt,
  KillswitchMutationReceipt$inboundSchema,
} from "./killswitchmutationreceipt.js";
import {
  KillswitchOverlap,
  KillswitchOverlap$inboundSchema,
} from "./killswitchoverlap.js";

export type KillswitchLiftResult = {
  remainingOverlaps: Array<KillswitchOverlap>;
  result: KillswitchMutationReceipt;
  truncated: boolean;
};

/** @internal */
export const KillswitchLiftResult$inboundSchema: z.ZodMiniType<
  KillswitchLiftResult,
  unknown
> = z.pipe(
  z.object({
    remaining_overlaps: z.array(KillswitchOverlap$inboundSchema),
    result: KillswitchMutationReceipt$inboundSchema,
    truncated: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "remaining_overlaps": "remainingOverlaps",
    });
  }),
);

export function killswitchLiftResultFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchLiftResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchLiftResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchLiftResult' from JSON`,
  );
}
